import { Box, Paper, Skeleton, Stack } from "@mui/material";

const barHeights = [120, 180, 220, 150, 90, 250, 180, 160, 190, 175];

export default function BudgetGraphSkeleton() {
  return (
    <Paper sx={{ p: 2 }}>
      {/* Header */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box>
          <Skeleton width={180} height={32} />
        </Box>

        <Stack direction="row" spacing={1}>
          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="circular" width={28} height={28} />
        </Stack>
      </Stack>

      {/* Toggle Buttons */}
      <Stack direction="row" spacing={1} mb={2}>
        <Skeleton variant="rounded" width={120} height={36} />
        <Skeleton variant="rounded" width={120} height={36} />
      </Stack>

      {/* Description */}
      <Skeleton width={320} height={20} sx={{ mb: 4 }} />

      {/* Budget Toggle */}
      <Box display="flex" justifyContent="flex-end" mb={3}>
        <Skeleton width={140} height={30} />
      </Box>

      {/* Chart Area */}
      <Box
        sx={{
          height: 320,
          borderBottom: "1px solid",
          borderColor: "divider",
          display: "flex",
          alignItems: "flex-end",
          gap: 2,
          px: 1,
        }}
      >
        {barHeights.map((height, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Skeleton variant="rounded" width="100%" height={height} />

            <Skeleton width="80%" height={16} />
          </Box>
        ))}
      </Box>

      {/* Footer */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Skeleton width={140} height={20} />

        <Stack direction="row" spacing={1}>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="circular" width={24} height={24} />
        </Stack>
      </Stack>
    </Paper>
  );
}
